import { useEffect, useState } from 'react';

const useCssVariables = () => {
  const [variables, setVariables] = useState<any>({});

  useEffect(() => {
    if (!document?.documentElement) return;

    const computedStyle = window.getComputedStyle(document.documentElement);

    const _variables = {};
    
    for (let i = 0; i < computedStyle.length; i++) {
      const prop = computedStyle[i];
      if (prop.startsWith('--')) {
        const val = computedStyle.getPropertyValue(prop);
        _variables[prop.substr(2)] = val;
      }
    }

    setVariables(_variables);
  }, []);

  return variables;
};

export default useCssVariables;